import React, { Component } from "react";
import { connect } from "react-redux";
import { Box, Theme, Grid, Typography } from '@material-ui/core/';
import * as actions from "../../../../store/actions/index";
import { withStyles } from '@material-ui/core/styles'
import {Styles} from "@material-ui/core/styles/withStyles";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {Helmet} from "react-helmet";
import CustomSnackBar from '../../creator/experienceManager/participantsDashboard/component/CustomSnackBar';
import clsx from 'clsx';
import Config from "../../../../config/config";


const useStyles: Styles<Theme, any, any> = () =>({
  appBar: {
    position: 'relative',
    background: 'none',
    boxShadow: 'none',
  },
  toolBar: {
    minHeight: 50,
  },
  layout: {
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop:'0',
    paddingLeft: '20px',
    paddingRight: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#d7d7d7',
    width: '100vw',
    backgroundImage: 'url(/assets/images/known/celebrate_header.png)',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom'
  },
  label: {
    "&$focusedLabel": {
      color: "#393c41"
    },
    "&$erroredLabel": {
      color: "#393c41"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#393c41',
    "&$error:after": {
      borderBottomColor: "#3177d8"
    },
    "&:after": {
      borderBottom: `2px solid #3177d8`
    }
  },

  registerlogocontainer:{
    textAlign:"left", 
    marginTop:"22px", 
    marginLeft:"40px",
    '@media (max-width: 768px)': {
      margin:"0 auto",
      marginTop:"20px",
      textAlign:"center", 
      width:"100%"
    },
  },
  registerLogo:{
    width: "188px",
    height: "27px",
    '@media (max-width: 768px)': {
      width:"100%"
    },
  },
  emailLogo:{
    width:"180px"
  },
  description:{
    textAlign: "center",
    font: "normal normal normal 24px/32px Roboto",
    color: "#393c41"
  },
  strongdescription:{
    font: "normal normal bold 24px/32px Roboto",
    color: "#393c41"
  },
  resenddescription:{
    font: "normal normal 300 18px/32px Roboto",
    color: "#393c41",
    marginBottom:"0"
  },
  resendlink:{
    font: "normal normal bold 18px/32px Roboto",
    color: "#3177d8",
    textDecoration: 'underline',
    marginTop:"0",
    cursor:"pointer",
    marginBottom:"0"
  },

  textCenter: {
    textAlign: 'center',
    color: '#393c41'
  },
  headline: {
    '@media (max-width: 960px)': {
      fontSize: '3.5rem',
    },
    '@media (max-width: 600px)': {
      fontSize: '2.5rem',
    },
  },
  logoFont: {
    fontFamily: 'Pacifico',
    color: '#3177d8'
  },
  smallText: {
    color: '#393c41'
  },
  actionButtons: {
    minWidth: '460px',
    marginBottom: '20px',
    '@media (max-width: 760px)': {
      minWidth: '250px'
    },
  },
  loginForm: {
    paddingTop: '20'
  },
  mainDiv: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },



  //general
  bottomleft:{
    textAlign:"left",
    '@media (max-width: 960px)': {
      textAlign:"center"
    },
  },
  bottomimageleft:{
    width: "354px",
    height: "161px",
    marginTop:"140px",
    marginLeft:"30px",
    '@media (max-width: 767px)': {
      margin:"0 auto",
      maxWidth: "354px",
      width:"100%"
    },
  },
  bottomright:{
    textAlign:"right",
    '@media (max-width: 960px)': {
      textAlign:"center",
    },
  },
  bottomimageright:{
    width: "374px",
    // height: "260px",
    marginRight:"30px",
    '@media (min-width: 768px) and (max-width:992px)': {
      marginRight:"0",
    },
    '@media (max-width: 767px)': {
      margin:"0 auto",
      width:"100%",
      maxWidth: "374px",
    },
  },

  error: {}
});

interface IProps {
  userInfo: any,
  apolloClient: any,
  classes: any,
  notification: any,
  ResendLink: (client: any, request: any) => void
}

interface IState {
  email: string,
  loading: boolean,
  snackAlertType:string,
  snackAlertMsg:string,
  isShownSnackAlert:boolean
}

class ConfirmEmail extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      email: "-",
      loading: false,
      snackAlertType:"success",
      snackAlertMsg:"",
      isShownSnackAlert:false
    };
  }

  // load int actions
  componentDidMount() {
    this.setState(
      { email: this.props.userInfo.email }, () => { this.forceUpdate(); }
    );
  }

  UNSAFE_componentWillReceiveProps(props: IProps) {
    if (props.notification) {
      this.setState({
        email: this.props.userInfo.email,
        loading: false
      })
      if(props.notification.success){
       this.setState({
        snackAlertMsg:"Email sent sucessfully.",
        isShownSnackAlert:true
       })   
      } else {
        this.setState({
          snackAlertType:"error",
          snackAlertMsg:"Problem occured while send email.",
          isShownSnackAlert:true
         })   
      }
    }
  }

  // resend link
  resendLink = () => {
    if (this.props.userInfo.email) {
      this.setState({ loading: true });
      const request = {
        email: this.props.userInfo.email,
        brand: Config.DEFAULT_SUBBRAND,
      };
      this.props.ResendLink(this.props.apolloClient.client, request)
    }
  };

  hideSnackAlert = () => {
    this.setState({
      isShownSnackAlert:false
    })
  }

  render() {
    const { classes } = this.props;
    const { loading } = this.state;
    return (
      <React.Fragment>
        <Helmet title="Confirm Email"/>
        
        <div className={classes.layout}>

        <Grid container spacing={3}>
              <Grid item xs={12} sm={6} >

          <Box className={classes.mainDiv}>
            <div className="login-form" style={{maxWidth:"unset"}}>
             

              <Typography variant="h1" component="h1" className={clsx(classes.textCenter, classes.headline)}>You know what to do next.</Typography>
            

              <p className={classes.description}>We&#39;ve sent an email to <strong className={classes.strongdescription}>{this.state.email}</strong>, when it arrives <strong className={classes.strongdescription}>click the link in the email</strong> to continue setting up your account.</p>

              <p className={classes.resenddescription}>If you don`t see the email, check your Spam/Promotions folder.</p>
              <p className={classes.resendlink}>
                <span onClick={() => this.resendLink()}> 
                  {loading && <CircularProgress color="inherit" size={20}/>}
                  {!loading && "or click here to resend the email."} 
                </span>
              </p>
            </div>
          </Box>
          </Grid>
              </Grid>

        </div>
        
        <CustomSnackBar type={this.state.snackAlertType} message={this.state.snackAlertMsg} open={this.state.isShownSnackAlert} onClose={this.hideSnackAlert} />
      </React.Fragment>
    );
  }
}

// load reducers
const mapStateToProps = (state: any) => {
  const { userInfo } = state.authUser;
  return {
    userInfo,
    apolloClient: state.apolloClient,
    notification: state.notification
  };
};

// load actions
const mapDispatchToProps = (dispatch: any) => {
  return {
    ResendLink: (client: any, request: any) => { dispatch(actions.ResendLink(client, request)); }
  }
};

const ConfirmEmailComponent = withStyles(useStyles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail));

export {
  ConfirmEmailComponent
}
